import { environment } from './environments/environment'

// https://developers.google.com/maps/documentation/javascript/overview#Dynamic
export function initMaps() {
  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.firebaseConfig.apiKey}`
  script.async = true
  document.head.appendChild(script)
}
